import React from 'react'
import AcquireWebComponent from '../framework/MaterialUI'

class InsightNavigation extends AcquireWebComponent {
	render(){

		return <div className="page-navigation" style={{height:'0px'}}></div>;
	}
}

export default InsightNavigation


// WEBPACK FOOTER //
// ./src/components/Insights/InsightNav.jsx